<template>
  <div id="meeting">
    <Nav />
    <div class="meetingMainList">
      <h3 class="title">请选择您要参加的会议</h3>
      <div class="meetCon" v-show="meetings&&meetings.length>0">
        <el-table
          :data="meetings"
          tooltip-effect="dark"
          style="width: 100%"
          ref="checkTable"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="AtyTheme"
            label="名称"
            width="120">
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column
            label="时间"
            width="240">
            <template slot-scope="scope">{{scope.row.AtyDate+ ' ' +scope.row.AtyBTime + '-' + scope.row.AtyETime}}</template>
          </el-table-column>
          <el-table-column
            prop="AtyPlace"
            label="地点"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="AtyContent"
            label="详情">
          </el-table-column>
        </el-table>
      </div>
      <div v-show="!(meetings&&meetings.length>0)" style="text-align:center; padding:50px 0 20px 0;">暂无数据</div>
      <div class="bmBtns">
        <el-button @click="refuseMeeting" v-if="!PsnID">我要观展</el-button>
        <el-button @click="submitMeet">我要报会</el-button>
      </div>
    </div>
    <div class="meetDetailModals" v-show="meetDetails">
      <div class="meetDetailCon">
        <p>会议详情</p>
        <table class="detail">
          <tr>
            <td width="50px" class="borR">名称：</td>
            <td>{{checkMeetingObj.AtyTheme}}</td>
          </tr>
          <tr>
            <td class="borR">费用：</td>
            <td>￥{{checkMeetingObj.AtyPrice}}</td>
          </tr>
          <tr>
            <td class="borR">时间：</td>
            <td>{{checkMeetingObj.AtyDate+ ' ' +checkMeetingObj.AtyBTime + '-' + checkMeetingObj.AtyETime}}</td>
          </tr>
          <tr>
            <td class="borR">地点：</td>
            <td>{{checkMeetingObj.AtyPlace}}</td>
          </tr>
          <tr>
            <td class="borR">简介：</td>
            <td>{{checkMeetingObj.AtyContent}}</td>
          </tr>
        </table>
        <div class="closeDetilBtn"><el-button @click="meetDetails=false">关闭</el-button></div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api/index.js'
import Nav from '../components/Nav'
export default {
  name: 'meeting',
  components: {
    Nav
  },
  data() {
    return{
      themeColor: sessionStorage.getItem('themeColor'),
      showMeetModals: false,
      meetDetails: false,
      checkList: [],
      ExhID: '',
      meetings: [],
      checkMeetingObj: {},
      unpayMeeting: [],
      ayids: [],
      bannerImg: sessionStorage.getItem('bannerImg'),
      PsnID: sessionStorage.getItem('PsnID') || ''
    }
  },
  mounted() {
    this.ExhID = sessionStorage.getItem('ExhID')
    this.getActivityList()
  },
  methods: {
    handleSelectionChange(val) {
      this.checkList = val;
    },
    refuseMeeting () {
      this.$router.push({
        path: 'confirmation',
        query: { ExhID: this.ExhID }
      })
    },
    async getActivityList () {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      await api.getActivityList({
        ExhID: this.ExhID
      }).then(res => {
        if(res.data.status === 'OK') {
          this.meetings = res.data.data
          if (this.meetings && this.meetings.length > 0) {
            this.meetings.map(item => {
              item.AtyDate = item.AtyDate.split(' ')[0]
              this.ayids.push(item.AtyID)
            })
          }
          this.getPersonAty()
        } else {
          this.$alert(res.data.ErrorMsg, '错误信息', {
            confirmButtonText: '确定',
            closeOnClickModal: true,
            type: 'error'
          });
        }
        loading.close()
      })
    },
    submitMeet () {
      if(this.checkList.length <= 0) {
        this.$alert('请选择会议！', '提示', {
          confirmButtonText: '确定',
          closeOnClickModal: true,
          type: 'tips'
        });
        return false;
      }
      var tmpArr = []
      // 提交会议数据格式
      if(this.checkList && this.checkList.length > 0) {
        this.checkList.map(item => {
          tmpArr.push(item.AtyID)
        })
      }
      // 提交会议
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.saveActivity({
        ExhID: this.ExhID,
        PsjID: sessionStorage.getItem('PsjID'),
        AtyIDs: tmpArr.join(',')
      }).then(res => {
        if (res.data.status === 'OK') {
          this.$router.push({
            path: 'confirmation',
            query: { ExhID: this.ExhID }
          })
          loading.close()
        } else {
          this.$alert(res.data.ErrorMsg, '错误信息', {
            confirmButtonText: '确定',
            closeOnClickModal: true,
            type: 'error'
          });
        }
      })
    },
    checkMeeting (AtyID) {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.getActivityDetail({
        ExhID: this.ExhID,
        AtyID: AtyID
      }).then(res => {
        if(res.data.status === 'OK') {
          for (var item in res.data.data) {
            if(item === 'AtyDate') {
              this.checkMeetingObj[item] = res.data.data[item].split(' ')[0]
            } else{
              this.checkMeetingObj[item] = res.data.data[item]
            }
          }
          this.meetDetails = true
          loading.close()
        } else {
          this.$alert(res.data.ErrorMsg, '错误信息', {
            confirmButtonText: '确定',
            closeOnClickModal: true,
            type: 'error'
          });
        }
      })
    },
    // 获取已报会
    getPersonAty () {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.getPersonAty({
        ExhID: this.ExhID,
        PsjID: sessionStorage.getItem('PsjID')
      }).then(res => {
        if (res.data.status === 'OK') {
          if (res.data.data) {
            res.data.data.map(item => {
              item.AtyDate = item.AtyDate.split(' ')[0]
              let index = this.ayids.indexOf(item.AtyID)
              if (index !== -1) {
                let _this = this
                setTimeout(function () {
                  _this.$refs.checkTable && _this.$refs.checkTable.toggleRowSelection(_this.meetings[index], true)
                }, 500)
              }
            })
          }
          loading.close()
        } else {
          this.$alert(res.data.ErrorMsg, '提示')
        }
      })
    }
  }
}
</script>
<style>
#meeting .banner{
  width:100%
}
#meeting .title{
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 60px 80px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
  margin:0;
}
#meeting .meetCon{
  padding: 30px 50px;
  background: #fff;
}
#meeting .meetList .meetItem{
  display: flex;
  text-align: left;
  padding: 10px 0;
  border-radius: 6px;
  border-bottom: 1px solid #ededed;
  margin:10px 0;
  justify-content: space-between;
  align-items: center;
}
#meeting .meetItemT{
  display:flex;
  align-items: center;
}
#meeting .meetItemT .el-checkbox__label{
  width: 230px;
  height: 25px;
  line-height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#meeting .meetItemFee{
  font-size: 12px
}
.meetItemT button{
  font-size: 12px;
  outline: none;
  position: static;
}
#meeting .bmBtns{
  padding: 45px 0;
  text-align: center;
  background: #fff;
}
#meeting .bmBtns .el-button{
  width: 20% !important;
  position: static !important;
  color: #FFF;
  background-color: #039dcf;
  border-color: #039dcf;
  margin:0 30px;
}
#meeting .meetDetailModals{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}
.meetDetailModals .meetDetailCon{
  width: 92%;
  border-radius: 4px;
  background: #fff;
  min-height: 120px;
  margin: 36px auto;
  border-radius: 4px;
  overflow: hidden;
}
.meetDetailCon .meetList{
  padding: 12px
}
.meetDetailCon p{
  padding: 12px 0;
  background: #eee;
  font-weight: bold;
  color: #888;
}
.meetDetailCon .modalBtns{
  padding: 20px 0;
}
.meetDetailCon .modalBtns .el-button{
  width: 28% !important;
  font-size: 12px;
  position: static !important;
}
.detail{
  width: 98%;
  margin: 12px auto;
  border-collapse: collapse;
}
.detail td{
  text-align: left;
  vertical-align: top;
  padding: 10px;
  border-bottom: 1px solid #ededed;
  line-height: 1.75
}
.detail .borR{
  border-right: 1px solid #ededed
}
.detail .closeDetilBtn{
  text-align: center;
  padding: 25px 0;
}
.detail .closeDetilBtn .el-button{
  width: 28% !important;
  position: static !important
}
</style>



// WEBPACK FOOTER //
// src/pages/Meeting.vue